// @flow
import get from 'lodash/get';
import { createSelector } from 'reselect';
import { isSpecificAbTestOptionById } from '../../Index/utils/common';
import { SOURCES_MODULE_NAME, REDIRECTING_TO_STATE_NAME, TEST_AB_IDS } from '../constants';
import { getAbTest } from '~/common/selectors/trovit';

export function isRedirectingToShow(state: Object) {
  return get(state[SOURCES_MODULE_NAME], [REDIRECTING_TO_STATE_NAME, 'isShow']);
}

export function getRedirectingToCount(state: Object) {
  return get(state[SOURCES_MODULE_NAME], [REDIRECTING_TO_STATE_NAME, 'count']);
}

export function getRedirectingToRedirectUrl(state: Object) {
  return get(state[SOURCES_MODULE_NAME], [REDIRECTING_TO_STATE_NAME, 'redirectUrl']);
}

export function getRedirectingToPublishYourCv(state: Object) {
  return get(state[SOURCES_MODULE_NAME], [REDIRECTING_TO_STATE_NAME, 'publishYourCv']);
}

export const shouldRedirectingLayoutShow = createSelector<Object, *, *, *, *>(
  [getRedirectingToCount, getAbTest],
  (count: number, testAb: Object): boolean =>
    isSpecificAbTestOptionById(testAb, TEST_AB_IDS.redirectingTo, 'b') && count < 3
);



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/selectors.js